import { useTheme as useEmotionTheme } from 'emotion-theming'

import { Theme } from '../types/theme'

export const useTheme = () => {
  return useEmotionTheme<Theme>()
}
